module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sale-details/sale-details.component.css
// module id = ./src/app/sale-details/sale-details.component.css
// module chunks = main